import { ExerciseAbcBase } from './exerciseAbcBase';

export class ExerciseAbc2 extends ExerciseAbcBase {
  constructor() {
    super('ExerciseAbc2', 2);
  }
}
